import { IconType } from "react-icons";
import { formatExpiryInterval } from "../utils/stats.util";

type SectionHeaderProps = {
  icon: IconType;
  title: string;
  updateInfo: number;
};

export const SectionHeader: React.FC<SectionHeaderProps> = ({ icon: Icon, title, updateInfo }) => {
  return (
    <div className="flex items-center justify-between mb-6">
      <div className="flex items-center gap-2">
        <Icon className="w-5 h-5 text-gray-700" />
        <h2 className="text-lg font-semibold text-gray-900">{title}</h2>
      </div>
      <div className="text-sm text-gray-500">{formatExpiryInterval(updateInfo)}</div>
    </div>
  );
};
